<div class="rating-overview">
  <h2>{{ 'RATING_OVERVIEW.TITLE' | translate }}</h2>

  <p *ngIf="loading" class="status">{{ 'RATING_OVERVIEW.LOADING' | translate }}</p>
  <p *ngIf="errorKey" class="status error">{{ errorKey | translate }}</p>

  <ng-container *ngIf="!loading && !errorKey">
    <div class="toolbar" *ngIf="ratings.length">
      <label class="sr-only" for="rating-search">{{ 'RATING_OVERVIEW.FILTER_PLACEHOLDER' | translate }}</label>
      <input
        id="rating-search"
        type="search"
        [placeholder]="'RATING_OVERVIEW.FILTER_PLACEHOLDER' | translate"
        [(ngModel)]="searchTerm"
        (ngModelChange)="onSearchTermChange($event)"
      />
      <button type="button" class="clear-button" *ngIf="isFilteringActive()" (click)="clearSearch()">
        {{ 'RATING_OVERVIEW.FILTER_CLEAR' | translate }}
      </button>
    </div>

    <p *ngIf="!ratings.length" class="status empty">
      {{ 'RATING_OVERVIEW.EMPTY' | translate }}
    </p>

    <p *ngIf="ratings.length && !filteredRatings.length" class="status empty">
      {{ 'RATING_OVERVIEW.NO_RESULTS' | translate }}
    </p>

    <p *ngIf="filteredRatings.length" class="status count">
      {{ 'RATING_OVERVIEW.RESULTS_COUNT' | translate: { count: filteredRatings.length } }}
    </p>

    <div *ngFor="let rating of filteredRatings; trackBy: trackByProperty" class="rating-card">
      <div class="rating-header">
        <h3>{{ rating.propertyAddress }}</h3>
        <span class="submitted-at">
          {{ 'RATING_OVERVIEW.SUBMITTED_AT' | translate }}
          {{ rating.summary?.lastSubmittedAt | date: 'medium' }}
        </span>
        <span class="submitted-at" *ngIf="rating.summary?.count">
          • {{ 'RATING_OVERVIEW.TOTAL_COUNT' | translate:{ count: rating.summary?.count ?? 0 } }}
        </span>
      </div>

      <div class="scores">
        <div class="score" *ngFor="let category of ratingCategories">
          <span class="label">
            {{ 'RATING_OVERVIEW.CATEGORIES.' + category.translationKey | translate }}
          </span>
          <nz-rate
            nzDisabled
            [nzAllowHalf]="true"
            [ngModel]="getCategoryAverage(rating, category.key)"
          ></nz-rate>
          <span class="numeric">{{ getCategoryAverage(rating, category.key) | number: '1.1-1' }}</span>
        </div>
      </div>

      <div class="average">
        <span class="label">{{ 'RATING_OVERVIEW.AVERAGE' | translate }}</span>
        <nz-rate
          nzDisabled
          [nzAllowHalf]="true"
          [ngModel]="rating.summary?.overallAverage ?? 0"
        ></nz-rate>
        <span class="numeric">{{ (rating.summary?.overallAverage ?? 0) | number: '1.1-1' }}</span>
      </div>

      <div class="card-actions">
        <button type="button" class="toggle-button" (click)="togglePropertyDetails(rating)">
          {{
            (isExpanded(rating.propertyId)
              ? 'RATING_OVERVIEW.COLLAPSE_DETAILS'
              : 'RATING_OVERVIEW.EXPAND_DETAILS')
              | translate
          }}
        </button>
      </div>

      <ng-container *ngIf="isExpanded(rating.propertyId)">
        <div class="rating-details" *ngIf="rating.ratings?.length; else noRatingDetails">
          <h4 class="details-title">{{ 'RATING_OVERVIEW.DETAILS_TITLE' | translate }}</h4>

          <div class="rating-detail" *ngFor="let detail of getVisibleDetails(rating); trackBy: trackByDetail">
            <div class="detail-header">
              <span class="detail-date">
                {{ detail.submittedAt ? (detail.submittedAt | date: 'medium') : ('RATING_OVERVIEW.UNKNOWN_DATE' | translate) }}
              </span>
              <div class="detail-overall">
                <span class="label">{{ 'RATING_OVERVIEW.OVERALL_SCORE' | translate }}</span>
                <nz-rate
                  nzDisabled
                  [nzAllowHalf]="true"
                  [ngModel]="detail.overall || 0"
                ></nz-rate>
                <span class="numeric">{{ (detail.overall || 0) | number: '1.1-1' }}</span>
              </div>
            </div>

            <div class="detail-scores">
              <div class="score" *ngFor="let category of ratingCategories">
                <span class="label">
                  {{ 'RATING_OVERVIEW.CATEGORIES.' + category.translationKey | translate }}
                </span>
                <nz-rate
                  nzDisabled
                  [nzAllowHalf]="true"
                  [ngModel]="$any(detail)[category.key] || 0"
                ></nz-rate>
                <span class="numeric">{{ ($any(detail)[category.key] || 0) | number: '1.1-1' }}</span>
              </div>
            </div>
          </div>

          <div
            class="detail-pagination"
            *ngIf="rating.ratings?.length && (hasMoreDetails(rating) || canShowLess(rating))"
          >
            <button
              type="button"
              class="link-button"
              *ngIf="hasMoreDetails(rating)"
              (click)="showMoreDetails(rating)"
            >
              {{ 'RATING_OVERVIEW.SHOW_MORE' | translate: { count: getNextBatchCount(rating) } }}
            </button>
            <button
              type="button"
              class="link-button"
              *ngIf="canShowLess(rating)"
              (click)="showLessDetails(rating)"
            >
              {{ 'RATING_OVERVIEW.SHOW_LESS' | translate }}
            </button>
          </div>
        </div>
        <ng-template #noRatingDetails>
          <p class="status empty">{{ 'RATING_OVERVIEW.DETAILS_EMPTY' | translate }}</p>
        </ng-template>
      </ng-container>
    </div>
  </ng-container>
</div>
